var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "imported-blocks" }, [
    _c(
      "div",
      { staticClass: "blocks-list" },
      _vm._l(_vm.blocks, function (importRecord) {
        return _c("div", { key: importRecord._id, staticClass: "block-item" }, [
          _c("div", { staticClass: "block-info" }, [
            _c("span", { staticClass: "material-icons block-icon" }, [
              _vm._v(
                _vm._s(_vm.$_.get(importRecord, "block.icon", "extension"))
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "block-details" }, [
              _c("h3", [
                _vm._v(
                  _vm._s(
                    importRecord.customName ||
                      _vm.$_.get(importRecord, "block.name", "Bilinmeyen Blok")
                  )
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$_.get(
                      importRecord,
                      "block.description",
                      "Bilinmeyen Blok"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "block-meta" },
                [
                  _c("span", { staticClass: "import-date" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("chatbotv2.imported") || "Imported") +
                        ":\n                            " +
                        _vm._s(_vm.formatDate(importRecord.importedAt)) +
                        "\n                        "
                    ),
                  ]),
                  _vm._v(" "),
                  !importRecord.versionId
                    ? _c("a-tag", { attrs: { color: "blue" } }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("chatbotv2.latest") || "Latest") +
                            "\n                        "
                        ),
                      ])
                    : _c("a-tag", { attrs: { color: "default" } }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("chatbotv2.pinned") || "Pinned") +
                            "\n                        "
                        ),
                      ]),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block-actions" },
            [
              _c(
                "a-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.viewDetails(importRecord.blockId)
                    },
                  },
                },
                [
                  _c("a-icon", { attrs: { type: "eye" } }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("chatbotv2.viewDetails") || "Details") +
                      "\n                "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-popconfirm",
                {
                  attrs: {
                    title:
                      _vm.$t("chatbotv2.confirmRemoveImport") ||
                      "Are you sure you want to remove this import?",
                  },
                  on: {
                    confirm: function ($event) {
                      return _vm.removeImport(importRecord.blockId)
                    },
                  },
                },
                [
                  _c(
                    "a-button",
                    { attrs: { size: "small", type: "danger" } },
                    [
                      _c("a-icon", { attrs: { type: "delete" } }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("chatbotv2.remove") || "Remove") +
                          "\n                    "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _vm.blocks.length === 0
      ? _c(
          "div",
          { staticClass: "empty-state" },
          [
            _c("a-empty", {
              attrs: {
                description:
                  _vm.$t("chatbotv2.noImportedBlocks") || "No imported blocks",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }